import { render } from "./dealerApproveForm.vue?vue&type=template&id=d5f0c3e6&scoped=true"
import script from "./dealerApproveForm.vue?vue&type=script&lang=js"
export * from "./dealerApproveForm.vue?vue&type=script&lang=js"

import "./dealerApproveForm.vue?vue&type=style&index=0&id=d5f0c3e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5f0c3e6"]])

export default __exports__